const SECURITY_ROOT = ["security"] as const

export const SECURITY_QUERY_KEYS = {
  root: SECURITY_ROOT,
  authHistoryRoot: [...SECURITY_ROOT, "auth-history"] as const,
  authHistory: (params: { offset: number; limit: number }) =>
    [...SECURITY_ROOT, "auth-history", params] as const,
  changePassword: [...SECURITY_ROOT, "change-password"] as const,
  verifyCurrentPassword: [...SECURITY_ROOT, "verify-current-password"] as const,
  activateGoogleAuthenticator: [...SECURITY_ROOT, "activate-google-authenticator"] as const,
  verifyGoogleAuthenticator: [...SECURITY_ROOT, "verify-google-authenticator"] as const,
  changeTwoFactor: [...SECURITY_ROOT, "change-two-factor"] as const,
  sendTwoFactorOtp: [...SECURITY_ROOT, "two-factor-send-otp"] as const,
  startAuthenticatorActivation: [...SECURITY_ROOT, "authenticator-start"] as const,
  confirmAuthenticatorActivation: [...SECURITY_ROOT, "authenticator-confirm"] as const,
  switchTwoFactorMethod: [...SECURITY_ROOT, "two-factor-switch"] as const,
  deactivateAuthenticator: [...SECURITY_ROOT, "authenticator-deactivate"] as const,
  sendLoginRecoveryOtp: [...SECURITY_ROOT, "login-recovery-send-otp"] as const,
  verifyLoginRecoveryOtp: [...SECURITY_ROOT, "login-recovery-otp"] as const,
  completeLoginRecovery: [...SECURITY_ROOT, "login-recovery-complete"] as const,
  recoverFromWithdrawal: [...SECURITY_ROOT, "withdrawal-recovery"] as const,
}

export const SECURITY_QUERY_OPTIONS = {
  staleTime: 0,
  refetchOnMount: "always" as const,
  refetchOnWindowFocus: true,
}
